import * as url from "../url_helper";

import { post } from "../api_helper";

export const addNotificationTemplate = data => post(url.ADD_NOTIFICATION_TEMPLATE, data);

export const getNotificationTemplate = data => post(url.GET_NOTIFICATION_TEMPLATE_LIST, data);

export const getTemplateNotification = data => post(url.GET_NOTIFICATION_TEMPLATE, data);

export const editNotificationTemplate = data => post(url.EDIT_NOTIFICATION_TEMPLATE, data);